import React from 'react';

const TagManager = () => {

    return <>
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MBJMB2HT"
            title="Google Tag Manager"
            className="hidden invisible"
            height="0"
            width="0"
        />
    </>
}

export default TagManager;